import { resolvedPropKey } from "./createStyle";
import { resolveStyledPropsValue } from "./resolveStyledProps";
import systemProps from "./systemProps";
import resolve from "@suid/css/resolve";
export function resolveSystemPropsValue(name, value, theme) {
    return systemProps[name](value, theme);
}
export function reslveSxPropsValue(name, value, theme) {
    return name in systemProps
        ? resolveSystemPropsValue(name, value, theme)
        : resolveStyledPropsValue(name, value);
}
function resolveSxProps(v, theme) {
    return resolve(v, (name, value) => reslveSxPropsValue(name, value, theme), {
        [resolvedPropKey]: true,
    });
}
export default resolveSxProps;
